# Route: /notifications  (F71 nav-notifications NavItem points here — xp85 §4)
# The current user's in-app notifications. Feature 83 — the whole read lifecycle
# (open a row → it is marked read AND opens its entry; "Mark all as read" clears
# the inbox; the header bell + Notifications nav badge decrement) is owned
# end-to-end by the <xp87-notification-list> widget.
#
# Why a widget and not a DataTable: the emitter's DataTable `row_action` can only
# navigate (never mark-read), and a PageHeader `type: custom` action can only
# dispatch a DOM event (never fetch a mutating endpoint) — so the former table +
# a "Mark all as read" header button whose `endpoint:`/`refetch:` keys the parser
# never read could not express "clicking a notification marks it read". The
# widget is the single canonical path (no-lasagna): one fetch, one mark-read,
# one mark-all, one empty state.
#
# Permission: Notification:read. Feature: F53b §C.5 → F83 (notification read
# lifecycle). Badge source of truth: GET /api/notifications/unread/count (the
# shell router polls it and re-reads on every xp85-data-changed the widget fires).

page-notifications:
  type: Page
  archetype: dashboard
  meta:
    title: $t.notif.meta_title
    route: /notifications
    layout: shell
    auth: required
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
    responsive:
      sm:
        padding: $spacing.sm
        padding_inline: $spacing.sm
        gap: $spacing.md
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - notifications-header
    - notifications-list

notifications-header:
  type: PageHeader
  content: $t.notif.title

# Read-lifecycle owner. The widget self-fetches GET /api/notifications, renders
# each row with the server-resolved names, marks a row read on open + navigates
# to its source entity, exposes "Mark all as read", and dispatches
# xp85-data-changed after every mutation so the header bell + nav badge
# decrement. i18n resolves at runtime from GET /api/locales/{lang}/ui
# (ui.notif.* keys), with an English fallback baked into the component.
notifications-list:
  type: Widget
  ref: xp87-notification-list
  permission: "Notification:read"
  params:
    api-url: /api/notifications
